import { DIVISION_LABEL, type Division } from '@masamune/shared';

export function DivisionTag({ division }: { division: Division }) {
  const key = division.toLowerCase();
  return (
    <span className="division-tag" data-div={key}>
      {DIVISION_LABEL[division]}
    </span>
  );
}
